export const basicFormData = () => ({
  inputData: {
    role_name: "",
    is_active: true,
    created_by: 1,
    updated_by: 1,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "role_masters",
    // whereCondition: {
    //   is_active: true,
    // },
  };

  const navigatePage = { back: "/role-list" };

  const headerName = "Role";

  const validationType = "RoleCreate";
  const createEndpoint = "/createRole";
  const updateEndpoint = "/updateRole";
  const getEndpoint = "/getRoleById";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "role_masters",
    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Role Name", value: "role_name" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/role-create",
    edit: "/role-create",
    view: "/role-view",
  };

  const searchfields = [
    "role_name",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "Role";
  const endpoint = "/listRole";
  const exportFileName = "roleData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "role_masters",
  relations: [
    { module: "user_masters", moduleAs: "createdBy" },
    { module: "user_masters", moduleAs: "updatedBy" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
